module.exports = __webpack_public_path__ + "img/ielts.d7c3cd35.png";